import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { getYearLabel } from '../../../Common/Util/getYearLabel';
import { useDataAggregation } from '../../Common/hooks/useAggregationData';
import { useCadUniqueChartsDataContext } from './hooks/useCadUniqueChartsDataContext';

export const AvgPeoplePerFamilyAnual = () => {
    const { chartData } = useCadUniqueChartsDataContext();

    const rawData = chartData?.avgPeoplePerFamilyAnual || [];

    const consolidatedData = useDataAggregation(rawData, 'ano', ['average_people_per_family', 'total_people', 'total_families']);

    const series = [
        {
            name: 'Média de Pessoas por Família',
            data: consolidatedData?.map(item => item.average_people_per_family)
        }
    ];
    

    return (
        <SimpleBars
            title={'Evolução anual das médias das pessoas por família'}
            horizontal={false}
            subtitles={rawData?.map((item) => getYearLabel(item.ano))}
            series={series}
            stacked
        />
    );
};
